import storeModule from '../../store-module'
import { defineStore } from 'pinia'

const url = 'settings/prices-table'

export default defineStore(
  'settings-prices-table',
  storeModule.createStoreModule('settings-prices-table', {
    createURL: url,
    fetchListURL: url,
    fetchSingleURL: ({ id }) => id ? `${url}/${id}` : `${url}/new`,
    updateURL: ({ id }) => `${url}/${id}`,
    destroyURL: ({ id }) => `${url}/${id}`
  })
)
